export const alarmConfig = {
  highVolt: {
    title: "alarms.highVolt",
    state: { description: "Röle-2 Yüksek Volt Hata Kontrol Aktivasyonu", address: 6153 },
    fields: [
      { key: "limit", label: "alarms.valueV", description: "Röle-2 Yüksek Volt Hata Limiti", address: 6154, factor: 0.1, min: 220, max: 260, divideByVTR: true },
      { key: "delay", label: "alarms.delayTime", description: "Röle-2 Yüksek Volt Hataya Girmesi için Geçmesi Gereken Süre", address: 6155, factor: 0.1 },
      { key: "return", label: "alarms.returnTime", description: "Röle-2 Yüksek Volt Hatadan Çıkması için Geçmesi Gereken Süre", address: 6156, factor: 0.1 },
      { key: "hysteresis", label: "alarms.hysteresis", description: "Röle-2 Yüksek Volt Hatadan Çıkış Histeriz Değeri", address: 6157, factor: 0.1, min: 2, max: 20 },
    ],
  },

  lowVolt: {
    title: "alarms.lowVolt",
    state: { description: "Röle-2 Düşük Volt Hata Kontrol Aktivasyonu", address: 6158 },
    fields: [
      { key: "limit", label: "alarms.valueV", description: "Röle-2 Düşük Volt Hata Limiti", address: 6159, factor: 0.1, min: 80, max: 220, divideByVTR: true },
      { key: "delay", label: "alarms.delayTime", description: "Röle-2 Düşük Volt Hataya Girmesi için Geçmesi Gereken Süre", address: 6160, factor: 0.1 },
      { key: "return", label: "alarms.returnTime", description: "Röle-2 Düşük Volt Hatadan Çıkması için Geçmesi Gereken Süre", address: 6161, factor: 0.1 },
      { key: "hysteresis", label: "alarms.hysteresis", description: "Röle-2 Düşük Volt Hatadan Çıkış Histeriz Değeri", address: 6162, factor: 0.1, min: 2, max: 20 },
    ],
  },

  highCurrent: {
    title: "alarms.highCurrent",
    state: { description: "Röle-2 Yüksek Akım Hata Kontrol Aktivasyonu", address: 6163 },
    fields: [
      { key: "limit", label: "alarms.valueA", description: "Röle-2 Yüksek Akım Hata Limiti", address: 6164, factor: 0.001, min: 0.2, max: 5.5, divideByCTR: true },
      { key: "delay", label: "alarms.delayTime", description: "Röle-2 Yüksek Akım Hataya Girmesi için Geçmesi Gereken Süre", address: 6165, factor: 1 },
      { key: "return", label: "alarms.returnTime", description: "Röle-2 Yüksek Akım Hatadan Çıkması için Geçmesi Gereken Süre", address: 6166, factor: 1 },
      { key: "hysteresis", label: "alarms.hysteresis", description: "Röle-2 Yüksek Akım Hatadan Çıkış Histeriz Değeri", address: 6167, factor: 0.1, min: 2, max: 20 },
    ],
  },

  lowCurrent: {
    title: "alarms.lowCurrent",
    state: { description: "Röle-2 Düşük Akım Hata Kontrol Aktivasyonu", address: 6168 },
    fields: [
      { key: "limit", label: "alarms.valueA", description: "Röle-2 Düşük Akım Hata Limiti", address: 6169, factor: 0.001, min: 0.2, max: 5.0, divideByCTR: true },
      { key: "delay", label: "alarms.delayTime", description: "Röle-2 Düşük Akım Hataya Girmesi için Geçmesi Gereken Süre", address: 6170, factor: 1 },
      { key: "return", label: "alarms.returnTime", description: "Röle-2 Düşük Akım Hatadan Çıkması için Geçmesi Gereken Süre", address: 6171, factor: 1 },
      { key: "hysteresis", label: "alarms.hysteresis", description: "Röle-2 Düşük Akım Hatadan Çıkış Histeriz Değeri", address: 6172, factor: 0.1, min: 2, max: 20 },
    ],
  },

  highNeutralCurrent: {
    title: "alarms.highNeutralCurrent",
    state: { description: "Röle-2 Yüksek Nötür Akım Hata Kontrol Aktivasyonu", address: 6173 },
    fields: [
      { key: "limit", label: "alarms.valueA", description: "Röle-2 Yüksek Nötür Akım Hata Limiti", address: 6174, factor: 0.001, min: 0.2, max: 5.5, divideByCTR: true },
      { key: "delay", label: "alarms.delayTime", description: "Röle-2 Yüksek Nötür Akım Hataya Girmesi için Süre", address: 6175, factor: 1 },
      { key: "return", label: "alarms.returnTime", description: "Röle-2 Yüksek Nötür Akım Hatadan Çıkması için Süre", address: 6176, factor: 1 },
      { key: "hysteresis", label: "alarms.hysteresis", description: "Röle-2 Yüksek Nötür Akım Histeriz", address: 6177, factor: 0.1, min: 2, max: 20 },
    ],
  },

  unbalanceVoltage: {
    title: "alarms.unbalanceVoltage",
    state: { description: "Röle-2 Gerilim Dengesizlik Hata Aktivasyonu", address: 6178 },
    fields: [
      { key: "limit", label: "alarms.valuePercent", description: "Röle-2 Gerilim Dengesizlik Limiti", address: 6179, factor: 0.1, min: 2, max: 99.9 },
      { key: "delay", label: "alarms.delayTime", description: "Röle-2 Gerilim Dengesizlik Hataya Girmesi için Süre", address: 6180, factor: 1 },
      { key: "return", label: "alarms.returnTime", description: "Röle-2 Gerilim Dengesizlik Hatadan Çıkması için Süre", address: 6181, factor: 1 },
      { key: "hysteresis", label: "alarms.hysteresis", description: "Röle-2 Gerilim Dengesizlik Histeriz", address: 6182, factor: 0.1, min: 2, max: 20 },
    ],
  },

  unbalanceCurrent: {
    title: "alarms.unbalanceCurrent",
    state: { description: "Röle-2 Akım Dengesizlik Hata Aktivasyonu", address: 6183 },
    fields: [
      { key: "limit", label: "alarms.valuePercent", description: "Röle-2 Akım Dengesizlik Limiti", address: 6184, factor: 0.1, min: 2, max: 99.9 },
      { key: "delay", label: "alarms.delayTime", description: "Röle-2 Akım Dengesizlik Hataya Girmesi için Süre", address: 6185, factor: 1 },
      { key: "return", label: "alarms.returnTime", description: "Röle-2 Akım Dengesizlik Hatadan Çıkması için Süre", address: 6186, factor: 1 },
      { key: "hysteresis", label: "alarms.hysteresis", description: "Röle-2 Akım Dengesizlik Histeriz", address: 6187, factor: 0.1, min: 2, max: 20 },
    ],
  },

  highFrequency: {
    title: "alarms.highFrequency",
    state: { description: "Röle-2 Yüksek Frekans Hata Aktivasyonu", address: 6188 },
    fields: [
      { key: "limit", label: "alarms.valueHz", description: "Röle-2 Yüksek Frekans Limiti", address: 6189, factor: 0.01, min: 50, max: 80 },
      { key: "delay", label: "alarms.delayTime", description: "Röle-2 Yüksek Frekans Hataya Girmesi için Süre", address: 6190, factor: 0.1 },
      { key: "return", label: "alarms.returnTime", description: "Röle-2 Yüksek Frekans Hatadan Çıkması için Süre", address: 6191, factor: 0.1 },
      { key: "hysteresis", label: "alarms.hysteresis", description: "Röle-2 Yüksek Frekans Histeriz", address: 6192, factor: 0.1, min: 2, max: 20 },
    ],
  },

  lowFrequency: {
    title: "alarms.lowFrequency",
    state: { description: "Röle-2 Düşük Frekans Hata Aktivasyonu", address: 6193 },
    fields: [
      { key: "limit", label: "alarms.valueHz", description: "Röle-2 Düşük Frekans Limiti", address: 6194, factor: 0.01, min: 40, max: 60 },
      { key: "delay", label: "alarms.delayTime", description: "Röle-2 Düşük Frekans Hataya Girmesi için Süre", address: 6195, factor: 0.1 },
      { key: "return", label: "alarms.returnTime", description: "Röle-2 Düşük Frekans Hatadan Çıkması için Süre", address: 6196, factor: 0.1 },
      { key: "hysteresis", label: "alarms.hysteresis", description: "Röle-2 Düşük Frekans Histeriz", address: 6197, factor: 0.1, min: 2, max: 20 },
    ],
  },

  phaseSequence: {
    title: "alarms.phaseSequence",
    state: { description: "Röle-2 Faz Sırası Hata Aktivasyonu", address: 6198 },
    fields: [
      { key: "delay", label: "alarms.delayTime", description: "Röle-2 Faz Sırası Hatasına Girmesi için Süre", address: 6199, factor: 0.1 },
      { key: "return", label: "alarms.returnTime", description: "Röle-2 Faz Sırası Hatasından Çıkması için Süre", address: 6200, factor: 0.1 },
    ],
  },

  phaseLoss: {
    title: "alarms.phaseLoss",
    state: { description: "Röle-2 Faz Yokluğu Hata Aktivasyonu", address: 6201 },
    fields: [
      { key: "delay", label: "alarms.delayTime", description: "Röle-2 Faz Yokluğu Hatasına Girmesi için Süre", address: 6202, factor: 0.1 },
      { key: "return", label: "alarms.returnTime", description: "Röle-2 Faz Yokluğu Hatasından Çıkması için Süre", address: 6203, factor: 0.1 },
    ],
  },

  latch: {
    title: "alarms.latch",
    state: { description: "Röle-2 Tutma Koruma Aktivasyonu", address: 6204 },
    fields: [],
  },

  inverse: {
    title: "alarms.inverse",
    state: { description: "Röle-2 Tersleme Aktivasyonu", address: 6205 },
    fields: [],
  },
};
